import { useDispatch } from 'react-redux';

import { useCreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod } from '@zg-rentals/ts-rent-payment-client-react-query';
import type { CreateRenterPaymentMethodWebApiResponseDto } from '@zg-rentals/ts-rent-payment-client';

import { closeNotification } from '@common/actions/NotificationActions';
import { REQUEST_CREATE_PAYMENT_METHOD } from '@renter-hub/constants/actionTypes';

export function useCreateRenterPaymentMethod({
  onSuccess,
  onError,
}: {
  onSuccess: (data: CreateRenterPaymentMethodWebApiResponseDto) => void | Promise<void>;
  onError: (error: unknown) => void | Promise<void>;
}) {
  const dispatch = useDispatch();

  return useCreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod({
    onMutate: async () => {
      await dispatch(closeNotification());
    },
    onSuccess: async (response: CreateRenterPaymentMethodWebApiResponseDto) => {
      dispatch({
        type: REQUEST_CREATE_PAYMENT_METHOD.SUCCESS,
        payload: {
          paymentMethod: response.paymentMethod,
        },
      });

      await onSuccess(response);
    },
    onError: async (error: any) => {
      let errorMessage: string | undefined;

      if (error?.errorDetails?.paymentMethodErrors) {
        errorMessage =
          error.errorDetails.paymentMethodErrors.paymentMethodInvalid ||
          error.errorDetails.paymentMethodErrors.paymentMethodCreationFailed ||
          error.errorDetails.paymentMethodErrors.paymentSourceBlacklisted;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }

      const errorToPass = errorMessage ? new Error(errorMessage) : error;
      await onError(errorToPass);
    },
  });
}
